<script setup lang="ts">
import type { AdvancedEventFilters, EventFilters } from '@/types/filters/EventFilters'
import { DatePickerField, StackLayout, StringInputField } from '@rfc/rfc-components-library'
import { EDebounceTime } from '@rfc/rfc-components-library/utils'
import { useDebounceFn } from '@vueuse/core'
import moment from 'moment'
import { ref } from 'vue'

type Props = {
    filters?: EventFilters & Partial<AdvancedEventFilters>
}

const props = defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<EventFilters>): void
}
const emit = defineEmits<Emits>()

const handleChange = (value?: string) => {
    loadingEvents.value = true
    debouncedQuestion(value)
}
const loadingEvents = ref(false)
const debouncedQuestion = useDebounceFn(
    (name?: string) => emit('change', { name }),
    EDebounceTime.DEFAULT
)

const handleStartAtChange = (value?: Date | null) => {
    const start_at = value ? moment(value).startOf('d').utc(true).toDate() : value
    const end_at =
        props.filters?.end_at && moment(props.filters?.end_at).isBefore(moment(value).startOf('d'))
            ? null
            : props.filters?.end_at
    emit('change', {
        start_at,
        end_at
    })
}
</script>

<template>
    <StackLayout :gap="8" class="w-full" isResponsive>
        <StringInputField
            :label="$t('event.filters.eventName')"
            :modelValue="filters?.name"
            @change="handleChange"
            class="w-full" />
        <StackLayout :gap="8" class="w-full" isResponsiveSmallScreen>
            <DatePickerField
                :label="$t('event.filters.startDate')"
                :modelValue="filters?.start_at"
                utc
                @change="handleStartAtChange"
                clearable
                class="w-full" />
            <DatePickerField
                :label="$t('event.filters.endDate')"
                :modelValue="filters?.end_at"
                utc
                @change="
                    $emit('change', {
                        end_at: $event ? moment($event).endOf('d').utc(true).toDate() : undefined
                    })
                "
                :min="filters?.start_at"
                clearable
                class="w-full" />
        </StackLayout>
        <slot />
    </StackLayout>
</template>
